import React, { useState } from "react";
import logo from "../assets/Academy/logo.png";
import Enroll from "../pages/Enroll";
import BookaCall from "../pages/CareerBookaCall";
import DownloadBrochure from "../pages/DownloadBrochure";
import tintImage from "../assets/Academy/tintImage.png";

const AcademySection1 = ({ academy }) => {
  const [isEnrollOpen, setIsEnrollOpen] = useState(false);
  const [isBookCallOpen, setIsBookCallOpen] = useState(false); 
  const [isDownloadBrochureOpen, setIsDownloadBrochureOpen] = useState(false);
  const [selectedAcademyBrochure, setSelectedAcademyBrochure] = useState(null);
  const handleDownloadBrochure = (academy) => {
  
    setSelectedAcademyBrochure(academy);
    setIsDownloadBrochureOpen(true);
  };
  return (
    <section className="font-display mt-16">
      <div className="w-full relative">
        {academy.academycoverImg?.url ? (
          <div className="relative">
            <div
              className="relative flex flex-col font-display justify-end items-start p-5 md:pt-36 mt-12 md:mt-10 2xl:mt-16 w-full"
              style={{
                position: "relative",
                aspectRatio: "16/9",
                minHeight: "300px",
                maxHeight: "550px",
                overflow: "hidden"
              }}
            >
              {/* Background cover image */}
              <div className="absolute inset-0">
                <img 
                  src={academy.academycoverImg.url} 
                  alt="Cover" 
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Tint image overlay with blend mode */}
              <div className="absolute inset-0">
                <img 
                  src={tintImage} 
                  alt="Overlay tint" 
                  className="w-full h-full object-cover mix-blend-overlay"
                  style={{ mixBlendMode: "multiply" }}
                />
              </div>

              <div className="absolute top-10 md:top-16 lg:top-20 left-6 md:left-10 lg:left-14 z-20">
                <img
                  src={logo}
                  alt="Randomwalk Logo"
                  className="w-32 md:w-44 lg:w-64 2xl:w-72"
                />
              </div>

              <article className="relative flex flex-col items-start md:flex-row md:items-end md:justify-between z-10 w-full">
                <div className="md:pb-10 pb-5 md:pl-2 pl-1 md:w-2/3 2xl:w-9/12">
                  <p className="text-white md:text-xl lg:text-3xl 2xl:text-4xl font-bold mb-2 md:mb-3 lg:mb-6 mt-0">
                    {academy.academyTitle}
                  </p>
                  <div className="text-white text-[9px] md:text-sm lg:text-lg 2xl:text-2xl font-medium drop-shadow-md">
                    <span>{academy.academyDesc}</span>
                  </div>
                </div>
              </article>
              
              <div className="flex md:flex-col gap-4 md:absolute md:bottom-12 lg:bottom-12 md:right-8 lg:right-20 2xl:bottom-16 md:mt-0 z-10">
                {academy.academyenroll && (
                  <button
                    onClick={() => setIsEnrollOpen(true)}
                    className="px-6 py-2 md:px-12 lg:px-16 lg:py-3 2xl:py-4 rounded-md shadow-md text-[10px] lg:text-sm font-medium font-display transition  
                    bg-[rgba(198,43,109,1)] text-white hover:bg-white hover:text-[rgba(198,43,109,1)]"
                  >
                    Enroll Now
                  </button>
                )}
                {academy.academyDownloadcourseguide && (
                  <button
                    onClick={() => handleDownloadBrochure(academy)}
                    className="px-4 py-3 md:px-12 lg:px-16 lg:py-3 2xl:py-4 rounded-md shadow-md text-[10px] lg:text-sm font-medium font-display border border-white text-white  
                    hover:bg-white hover:text-gray-900 transition"
                  >
                    Download Brochures
                  </button>
                )}

                {academy.academyBookCall && (
                  <button
                    onClick={() => setIsBookCallOpen(true)}
                    className="px-4 py-3 md:px-12 lg:px-16 lg:py-3 2xl:py-4 rounded-md shadow-md text-[10px] lg:text-sm font-medium font-display border border-white text-white  
                    hover:bg-white hover:text-gray-900 transition"
                  >
                    Book a Call
                  </button>
                )}
              </div>
              
              <Enroll 
                isOpen={isEnrollOpen} 
                onClose={() => setIsEnrollOpen(false)} 
                academyTitle={academy.academyTitle}
                courseType="CareerAdvancementCourses" 
              />
              
              <BookaCall isOpen={isBookCallOpen} onClose={() => setIsBookCallOpen(false)} /> 
              {selectedAcademyBrochure && (
        <DownloadBrochure 
          isOpen={isDownloadBrochureOpen} 
          onClose={() => setIsDownloadBrochureOpen(false)}
          utmContent="corporate-courses"
          academyTitle={selectedAcademyBrochure.academyTitle || ''}
          brochureUrl={
            selectedAcademyBrochure.academyDownloadBrochure && 
            selectedAcademyBrochure.academyDownloadBrochure.length > 0 
              ? selectedAcademyBrochure.academyDownloadBrochure[0].url 
              : ''
          }
          academyBrochureImage={selectedAcademyBrochure.academyBrochureImage}
        />
      )}
            </div>
          </div>
        ) : (
          <div className="bg-gray-200 w-full h-64 flex justify-center items-center rounded-lg">
            <p className="text-gray-500">No cover image available</p>
          </div>
        )}
      </div>
      <style>
        {`
          .clip-polygon {
            clip-path: polygon(0% 0%, 100% 0%, 100% 80%, 50% 100%, 0% 80%);
          }
        `}
      </style>
    </section>
  );
};

export default AcademySection1;